import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';

export default function BackButton({ onClick, ...props }) {
  const { t } = useTranslation();

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<ArrowBackIcon />}
      onClick={onClick}
      {...props}
    >
      {t('Go_back')}
    </Button>
  );
}
